import { Box, Button, Chip, Link, Typography, styled } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';

export const PageToolbar = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 32,
});

export const BackButton = styled(Button)({
  fontWeight: 700,
  paddingLeft: 0,
  textTransform: 'none',
});

export const Section = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: 32,
  paddingBottom: 32,
  '&:last-of-type': {
    borderBottom: 'none',
    marginBottom: 0,
    paddingBottom: 0,
  },
}));

export const SectionTitle = styled(Typography)({
  fontWeight: 700,
  marginBottom: 24,
});

export const InfoGrid = styled(Box)({
  display: 'grid',
  gap: 32,
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
});

export const InfoField = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

export const InfoFieldHeader = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  gap: 8,
});

export const InfoFieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontWeight: 600,
}));

export const InfoFieldValue = styled(Typography)({
  fontFamily: 'Open Sans',
  fontSize: 16,
  lineHeight: '28px',
  paddingLeft: 32,
});

export const ChipRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
});

export const AccountChip = styled(Chip)({
  fontWeight: 700,
});

export const LocationChip = styled(Chip)({
  fontWeight: 700,
});

export const LocationGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '&:not(:last-child)': {
    marginBottom: 24,
  },
});

export const LocationSite = styled(Typography)({
  fontSize: 14,
  fontWeight: 600,
});

export const MembersDataGrid = styled(DataGrid)({
  backgroundColor: '#fff',
  border: 0,
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#fff',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: '#fff',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnSeparator': {
    color: 'rgba(224, 224, 224, 1)',
    opacity: '1 !important',
    visibility: 'visible',
  },
  '& .MuiDataGrid-cell': {
    fontFamily: 'Open Sans',
    fontSize: 14,
  },
  '& .MuiDataGrid-row': {
    backgroundColor: '#fff',
  },
  '& .MuiDataGrid-filler': {
    backgroundColor: '#fff',
  },
});

export const EmailCell = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  gap: 8,
});

export const EmailLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 14,
}));
